export const ADMIN_URL = 'https://admin.sits.org.pl'
export const SCHOOL_URL = 'https://school.sits.org.pl'
export const API_URL = 'https://api.sits.org.pl'
export const DOMAIN_URL = 'sits.org.pl'
